// Hooks (@tanstack/react-query) imports
import { useMutation } from "@tanstack/react-query";

// Configs imports
import api from "../../app/api";

// Custom types imports
import { ApiErrorResponse } from "apisauce";

interface paramsType {
  email: string;
  role: number;
  companyID?: number;
  isActive?: boolean;
  notificationID: string | number;
}

export function useAddRoleUserMutation(
  onSuccessMutation?: (data: any, variables: paramsType) => void,
  onErrorMutation?: (err: ApiErrorResponse<any>, variables: paramsType) => void
) {
  async function addRoleUser(params: paramsType): Promise<any> {
    const response = await api.post<any>(
      `admin/addrole/${params.email}/${params.role}`,
      {},
      {
        params: {
          companyID: params.companyID || 0,
          isActive: params.isActive || false,
        },
      }
    );

    if (!response.ok) {
      throw response;
    }

    return response.data;
  }

  return useMutation({
    mutationFn: addRoleUser,
    onSuccess: onSuccessMutation,
    onError: onErrorMutation,
  });
}
